export const LOCAL_FILTER_FIELDS = [
    {
        label: "Product Id",
        type: "text",
        name: "itemCode",
    },
    {
        label: "Product Description",
        type: "text",
        name: "itemName",
    },
    {
        label: "Category",
        type: "text",
        name: "itemGroupCode",
    },
    {
        label: "Branch Code",
        type: "text",
        name: "locationCode",
    }
]